import { MinusIcon } from 'lucide-react'

import { DelayedComponent } from '@/ui/atoms/delayed-component/DelayedComponent'
import { ExternalLink } from '@/ui/atoms/link/Link'
import { NetworkBadge } from '@/ui/atoms/network-badge/NetworkBadge'
import { links } from '@/ui/constants/links'
import { Info } from '@/ui/molecules/info/Info'

export interface PageHeaderProps {
  chainId: number | undefined
}
export function PageHeader({ chainId }: PageHeaderProps) {
  return (
    <div className="flex items-baseline gap-1">
      <h1 className="typography-heading-1 flex items-center gap-1">
        Savings
        <Info className="mt-2 sm:mt-3">
          Spark Savings lets you earn rewards across different vaults: from upgraded Savings v2 accounts to higher-yield
          opportunities. Previous versions remain accessible under Legacy.{' '}
          {import.meta.env.VITE_BASE_MINI_APP !== '1' && (
            <ExternalLink to={links.docs.savings.earningSavings}>Learn more</ExternalLink>
          )}
        </Info>
      </h1>
      {chainId && (
        <DelayedComponent>
          <MinusIcon className="rotate-90 text-neutral-200" />
          <NetworkBadge chainId={chainId} />
        </DelayedComponent>
      )}
    </div>
  )
}
